export type EmailChannelName = "work_email" | "personal_email";
export type ChatChannelName = "slack" | "teams";
type TextChannelName = "twilio";
type WhatsAppChannelName = "whatsapp";
export type ChannelName =
  EmailChannelName | ChatChannelName | TextChannelName | WhatsAppChannelName | null;

export const Channels: Record<
  NonNullable<ChannelName>,
  { name: ChannelName; type: string; buttonText: string }
> = {
  work_email: { name: "work_email", type: "email", buttonText: "Work Email" },
  personal_email: { name: "personal_email", type: "email", buttonText: "Personal Email" },
  slack: { name: "slack", type: "chat", buttonText: "Slack" },
  teams: { name: "teams", type: "chat", buttonText: "Teams" },
  twilio: { name: "twilio", type: "text", buttonText: "SMS" },
  whatsapp: { name: "whatsapp", type: "whatsapp", buttonText: "WhatsApp" },
} as const;

export const isEmailChannel = (
  channel?: string | null,
): channel is "personal_email" | "work_email" =>
  channel === "personal_email" || channel === "work_email";

export const isChatChannel = (channel?: string | null): channel is "slack" | "teams" =>
  channel === "slack" || channel === "teams";

export const isTextChannel = (channel?: string | null): channel is "twilio" => channel === "twilio";
